import styled, { css } from 'styled-components';
import Image from 'next/image';
import Link from 'next/link';
import {
  FlexBetween,
  FlexColumn,
  FlexibleDiv
} from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';
import { tagStyles } from '../../../ui/Typography/styles';

export const ownerSectionStyles = css`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 30px;
    height: max-content;
    background-color: ${({ theme }) => theme.colors.background.tertiary};
    margin: 0;
    width: 310px;
    position: sticky;
    top: 0;
  }
`;

export const OwnerContainer = styled(FlexColumn)`
  gap: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 20px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 0;
  }
`;

export const OwnerData = styled(FlexBetween)`
  gap: 20px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding-bottom: 20px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
    gap: 10px;
  }
`;

export const OwnerDataContent = styled(FlexColumn)`
  gap: 2px;
`;

export const OwnerName = styled(Typography)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${tagStyles.h4_new};
  }
`;

export const OwnerType = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const OwnerLogo = styled(Image)`
  width: 60px;
  height: 60px;

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 100px;
    height: 100px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    width: 55px;
    height: 55px;
  }
`;

export const ScheduleAndLocationBlock = styled(FlexColumn)`
  gap: 10px;
  padding-bottom: 20px;

  @media screen and (max-width: ${({ theme }) =>
      theme.smallDesktopBreakpoint}) {
    path {
      fill: ${({ theme }) => theme.colors.text.tertiary};
    }
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding-bottom: 0;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-bottom: 20px;
  }
`;

export const BlockRow = styled(FlexibleDiv)`
  gap: 10px;
  align-items: center;
`;

export const ScheduleAndLocationText = styled(Typography)<{
  $isLocation: boolean;
}>`
  flex: 1;

  ${({ $isLocation }) =>
    $isLocation &&
    css`
      transition: all 0.2s ease-in-out;
      text-decoration: underline;
      cursor: pointer;

      @media (hover: hover) {
        &:hover {
          color: ${({ theme }) => theme.colors.systemColors.blue};
        }
      }
    `}
`;

export const ApartmentsInfoContainer = styled(FlexColumn)`
  display: none;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: flex;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
    margin-bottom: 20px;
  }
`;

export const ContactsContainer = styled(FlexibleDiv)`
  gap: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding-top: 20px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const ContactLink = styled(Link)`
  padding: 10px 15px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme }) => theme.colors.systemColors.blue};
  font-size: 15px;
  white-space: nowrap;
`;
